export default "__VITE_ASSET__XPB1BkuF__"